module.exports = __webpack_public_path__ + "icon_services_status_continue.116f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_services_status_continue.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_services_status_continue.svg
// module chunks = main